import React, { useEffect, useState } from "react";
import { PopulationTrend } from "../common/ObjectTypes";
import PopulationTrendController from "./PopulationTrendController";
import {
  createPopulationTrend,
  deleteTrend,
  getPopulationTrends,
  updatePopulationTrend,
} from "../../api/populationtrend/populationtrendApi";
import { toast } from "react-toastify";
import { MoonLoader } from "react-spinners";

const ManagePopulationTrendController = () => {
  const [pageLoaded, setPageLoaded] = useState(false);
  const [populationTrends, setPopulationTrends] = useState<PopulationTrend[]>(
    []
  );
  const [addTrend, setAddTrend] = useState(false);
  const [selectedTrend, setSelectedTrend] = useState<PopulationTrend>({
    name: "",
    id: "",
    description: "",
  });
  const [trendToAdd, setTrendToAdd] = useState<PopulationTrend>({
    name: "",
    id: "",
    description: "",
  });
  useEffect(() => {
    const loadTrends = async () => {
      try {
        const temp = await getPopulationTrends();
        setPopulationTrends(temp);
        setPageLoaded(true);
      } catch (err) {
        console.log(err);
      }
    };
    loadTrends();
  }, [pageLoaded]);

  const handleSelectTrend = (populationtrend: PopulationTrend) => {
    setSelectedTrend({
      name: populationtrend.name,
      id: populationtrend.id,
      description: populationtrend.description,
      rowVersion: populationtrend.rowVersion,
    });
  };

  const handleOnClickAdd = () => {
    setAddTrend(true);
  };

  const handleCancelEdit = () => {
    setSelectedTrend({
      name: "",
      id: "",
      description: "",
    });
  };

  const handleCancelAdd = () => {
    setAddTrend(false);
  };

  const handleChange = (e: any) => {
    setSelectedTrend((prev: PopulationTrend) => ({
      ...prev,
      name: e.target.value,
    }));
  };

  const handleChangeNewTrend = (e: any) => {
    setTrendToAdd((prev: PopulationTrend) => ({
      ...prev,
      name: e.target.value,
    }));
  };

  const handleUpdateTrend = async () => {
    try {
      await updatePopulationTrend(selectedTrend);
      toast.success("Trend updated.", {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 2500,
      });
      setPageLoaded(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSaveNew = async () => {
    try {
      await createPopulationTrend({
        name: selectedTrend.name,
        description: "",
      });
      toast.success(selectedTrend.name + " added.", {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 2500,
      });
      setAddTrend(false);
      setPageLoaded(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleDelete = async () => {
    try {
      await deleteTrend(selectedTrend.id ? selectedTrend.id : "");
      setSelectedTrend({
        name: "",
        id: "",
        description: "",
      });
      toast.success("Population trend was deleted.", {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 2500,
      });
      setPageLoaded(false);
    } catch (error) {
      console.log(error);
    }
  };

  return !pageLoaded ? (
    <div>
      <MoonLoader color="#9EB45B" />
    </div>
  ) : (
    <div className="h-full">
      <PopulationTrendController
        populationTrends={populationTrends}
        selectedTrend={selectedTrend}
        trendToAdd={trendToAdd}
        addTrend={addTrend}
        onSelectTrend={handleSelectTrend}
        onClickAdd={handleOnClickAdd}
        onCancelEdit={handleCancelEdit}
        onCancelAdd={handleCancelAdd}
        onChange={handleChange}
        onChangeNewTrend={handleChangeNewTrend}
        onUpdateTrend={handleUpdateTrend}
        onSaveNew={handleSaveNew}
        onDelete={handleDelete}
      />
    </div>
  );
};

export default ManagePopulationTrendController;
